module.exports = __webpack_public_path__ + "media/images/main-bg-p-2600-ed92f09c0b206b249ad2f08ff05002f5.jpeg";